import ApiService from '@/services/api.service';
import getters from '@/store/global';

const state = {
    messages: [],
    count: '',
    next: '',
    prev: '',
    activeThread: '',
    counter: 0,
    newCount: 0,
    errors: {}
};

getters['fetchMessages'] = function(state) {
    if (state.messages) {
        return state.messages;
    }
    return {}
}
getters['fetchMessagesNext'] = function(state) { return state.next; }
getters['fetchMessagesPrev'] = function(state) { return state.prev; }
getters['fetchActiveThread'] = function(state) { return state.activeThread; }
getters['fetchMessagesNewCount'] = function(state) { return state.newCount; }

const actions = {
    getMessages(context, payload) {
        return ApiService
            .get('messages/thread/' + payload + '/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_NEW_COUNT', response.data.results);
                context.commit('SET_MESSAGES', response.data.results);
                context.commit('SET_COUNT', response.data.count);
                context.commit('SET_NEXT', response.data);
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    },
    getNext(context) {
        return ApiService
            .get(context.state.next)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_NEW_COUNT', response.data.results);
                context.commit('ADD_MESSAGES', response.data.results);
                context.commit('SET_NEXT', response.data);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    getPrev(context) {
        return ApiService
            .get(context.state.prev)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_NEW_COUNT', response.data.results);
                context.commit('ADD_PREV_MESSAGES', response.data.results);
                context.commit('SET_PREV', response.data);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    getByPage(context, payload) {
        return ApiService
            .get('messages/thread/' + payload.id + '/?page=' + payload.page)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_NEW_COUNT', response.data.results);
                context.commit('SET_MESSAGES', response.data.results);
                context.commit('SET_NEXT', response.data);
                context.commit('SET_PREV', response.data);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    createMessage(context, payload) {
        let tempId = context.state.counter;
        context.commit(
            'SET_TEMP_MESSAGE',
            {payload: payload, tempId: tempId}
        );
        return ApiService
            .post('messages/thread/' + payload.id + '/create_message/', payload.data)
            .then((response) => {
                context.commit('SET_ERROR', {});
                // TODO: если будут прочитанные/непрочитанные, проверить
                // context.commit('ADD_MESSAGE', response.data);
                context.commit('SET_SENDED_MESSAGE', {
                    tempId: tempId, data: response.data
                });
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    deleteMessage(context, payload) {
        return ApiService
            .delete('messages/delete_message/' + payload + '/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('DELETE_MESSAGE', payload);
            })
            .catch(() => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    clearMessages(context, payload) {
        return ApiService
            .delete('messages/thread/' + payload + '/clear/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('CLEAR_MESSAGES');
            })
            .catch(() => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    createDialog(context, payload) {
        return ApiService
            .post('profile/' + payload.id + '/create_message/', payload.data)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('ADD_MESSAGE', response.data);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    setSpam(context, payload) {
        return ApiService
            .get('messages/' + payload + '/spam/')
            .then((response) => {
                context.commit('SET_ERROR', {});
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    getEmptyMessages(context) {
        context.commit('CLEAR_MESSAGES');
    },
    addFromFront(context, payload) {
        context.commit('ADD_MESSAGE', payload);
    },
    setActiveThread(context, payload) {
        context.commit('SET_ACTIVE_THREAD', payload);
    },
};

const mutations = {
    SET_MESSAGES(state, messages) {
        for (let key in messages) {
            messages[key].time = 
            new Date(messages[key].time * 1000);
        };
        state.messages = messages;
        state.errors = {};
    },
    ADD_MESSAGES(state, messages) {
        for (let key in messages) {
            messages[key].time = 
            new Date(messages[key].time * 1000);
        };
        state.messages = messages.concat(state.messages);
        state.errors = {};
    },
    ADD_PREV_MESSAGES(state, messages) {
        for (let key in messages) {
            messages[key].time = 
            new Date(messages[key].time * 1000);
        };
        state.messages = state.messages.concat(messages);
        state.errors = {};
    },
    ADD_MESSAGE(state, message) {
        message.time = 
        new Date(message.time * 1000);
        state.messages.push(message);
        state.errors = {};
    },
    DELETE_MESSAGE(state, id) {
        for (let i in state.messages) {
            if (state.messages[i].id == id) {
                state.messages.splice(i, 1);
            }
        }
    },
    CLEAR_MESSAGES(state) {
        state.messages = [];
    },
    SET_COUNT(state, count) {
        state.count = count;
        state.errors = {};
    },
    SET_NEW_COUNT(state, messages) {
        state.newCount = 0;
        const cloneMessages = messages.slice();
        for (let i in cloneMessages) {
            if (cloneMessages[i].read === 0) {
                state.newCount++;
            }
        }
    },
    SET_NEXT(state, data) {
        if (data.page < data.num_pages) {
            state.next =
            data.url +
            '?' +
            data.page_param +
            '=' +
            (data.page + 1);
        } else {
            state.next = '';
        }
        state.errors = {};
    },
    SET_PREV(state, data) {
        if (data.page > 1) {
            state.prev =
            data.url +
            '?' +
            data.page_param +
            '=' +
            (data.page - 1);
        } else {
            state.prev = '';
        }
    },
    SET_ACTIVE_THREAD(state, activeThread) {
        state.activeThread = activeThread;
    },
    SET_TEMP_MESSAGE(state, tempMessage) {
        state.counter++;
        let newMessage = {};
        newMessage.thread = tempMessage.payload.id;
        newMessage.id = 0;
        newMessage.tempId = tempMessage.tempId;
        newMessage.text = tempMessage.payload.data.text;
        newMessage.image = tempMessage.payload.data.image || null;
        newMessage.sender = {};
        newMessage.sender.id = tempMessage.payload.user.id;
        newMessage.sender.name = tempMessage.payload.user.first_name +
            ' ' + tempMessage.payload.user.last_name;
        newMessage.sender.avatar = tempMessage.payload.user.avatar;
        newMessage.time = +new Date();
        state.messages.push(newMessage);
    },
    SET_SENDED_MESSAGE(state, sendedMessage) {
        for (let i in state.messages) {
            if (state.messages[i].tempId == sendedMessage.tempId) {
                for (let j in sendedMessage.data) {
                    state.messages[i][j] = sendedMessage.data[j]
                }
                state.messages[i].time = 
                new Date(state.messages[i].time * 1000);
                break;
            }
        }
    },
    SET_SPAM(state, spam) {
        for (let i in state.messages) {
            if (state.messages[i].id == spam) {
                state.messages[i].spam = true;
            }
        }
    },
    SET_ERROR(state, errors) {
        state.errors = errors;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
